export const getAuthUrl = (id: string, auth: 'saml' | unknown) =>
  `/auth/${auth}/${id}${auth === 'saml' ? '/sso' : ''}`;
